import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "progress-line-container" }
const _hoisted_2 = { class: "progress-line-round" }
const _hoisted_3 = {
  key: 0,
  class: "progress-line-label"
}

import { computed, onMounted, onBeforeUnmount, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressLine',
  props: {
    width: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;

const windowWidth = ref(window.innerWidth);

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

const progressStyle = computed(() => {
  const size = `${props.width - 1}%`;
  return {
    display: props.width ? 'block' : 'none',
    ...(windowWidth.value >= 1280 ? { width: size } : { height: size }),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "progress-line-fill",
      style: _normalizeStyle(progressStyle.value)
    }, [
      _createElementVNode("span", _hoisted_2, [
        (__props.label)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.label), 1))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}
}

})